export default __webpack_public_path__ + "static/media/packaged_liquid_biofuel.637b49b5.png";